import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { ViewerComponent } from './viewer.component'

@NgModule({
  imports: [
    RouterModule.forChild([
      { path: ':code', component: ViewerComponent },
    ]),
  ],
  exports: [
    RouterModule,
  ],
})
export class ViewerRoutingModule {}
